<div class="panel">
  <!-- Default panel contents -->
  <div class="panel-heading text-center pt-2">
    <h3 class="panel-title">{{title}}</h3>
  </div>

  <!-- Table -->

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <caption class="d-none"> {{title}} </caption>
      <thead>
        <tr>
          <th *ngFor="let column of columnsNames" scope="col" class="text-center">{{ column | titlecase }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data | slice:0:maxRows">
          <td *ngFor="let column of internalColumnsNames"
              (mouseenter)="setHovered(row, true)"
              (mouseleave)="setHovered(row, false)"
              class="text-center"
              [point]='{name: row[internalColumnsNames[0]]}'>
              {{ row[column] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
